module.exports = __webpack_public_path__ + "img/download.08ccddb8.png";